import React, { forwardRef } from "react";
import {
  Ellipsis,
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { useNavigate } from "react-router";
import type { BreadcrumbLinkProps } from "../Breadcrumb.types";
import styles from "./BreadcrumbLink.module.css";
import { CatalystColors } from "@certa/catalyst/constants/styles";

const BreadcrumbLink = forwardRef<HTMLLIElement, BreadcrumbLinkProps>(
  ({ link, maxWidth, onLinkClick }, ref) => {
    const navigate = useNavigate();

    const handleClick = () => {
      if (link.url) {
        navigate(link.url);
      }
      if (link.onClick) {
        link.onClick();
      }
      onLinkClick?.();
    };

    return (
      <li
        ref={ref}
        className={styles.breadcrumbLinkWrapper}
        style={
          maxWidth
            ? {
                maxWidth,
                flexGrow: 0,
                flexBasis: "auto"
              }
            : undefined
        }
      >
        <button onClick={handleClick} className={styles.breadcrumbLink}>
          {!!link.leftIcon &&
            link.leftIcon({
              color: CatalystColors.NEUTRAL_700,
              size: 16,
              className: styles.leftIcon
            })}
          <Typography
            color={TypographyColors.NEUTRAL_700}
            variant={TypographyVariants.LABEL_SM}
            as="span"
            className="overflow-hidden"
          >
            <Ellipsis>{link.label}</Ellipsis>
          </Typography>
        </button>
      </li>
    );
  }
);

export { BreadcrumbLink };
